import { FC } from 'react';
import intl from 'react-intl-universal';
import { Tooltip, Typography } from '@getsynapse/design-system';
import { useSelector } from 'react-redux';
import { RootState } from 'state/store';
import { selectProgramsById } from 'state/ProjectsList/include/programsSlice';

interface ProjectProgramsProps {
  programs?: string[];
}

const ProjectPrograms: FC<ProjectProgramsProps> = ({ programs = [] }) => {
  const projectPrograms = useSelector((state: RootState) =>
    selectProgramsById(state, programs)
  );

  if (projectPrograms.length === 0) {
    return null;
  }

  if (projectPrograms.length === 1) {
    return <>{projectPrograms[0].title}</>;
  }

  const programNames = projectPrograms.map((program) => program.title);
  const label = intl.get('PROJECTS_LIST_PAGE.TABLE.PROGRAM_COUNT', {
    count: projectPrograms.length,
  });

  return (
    <Tooltip
      trigger={<span>{label}</span>}
      openMode='hover1'
      position='topCenter'
      timeout={0}
      showPopper
      usePortal
      contentProps={{
        className:
          'bg-neutral-darker shadow-tooltip rounded-xs px-2 py-1 text-sm z-50',
      }}
    >
      <Typography variant='body' className='text-neutral-white'>
        {programNames.join(', ')}
      </Typography>
    </Tooltip>
  );
};

export default ProjectPrograms;
